export default __webpack_public_path__ + "static/media/ios_badge.e16ed416.svg";